export default {
  type: 'home',
  aliases: ['home'],
  slices: [{
    name: 'home_products',
    path: 'Home/HomeProducts.vue',
    additional: {
      query: 'products',

      handler(arg) {
        return {
          references: arg.items.map(e => e.reference)
        };
      }

    }
  }, {
    name: 'eb_products_carousel',
    path: 'Global/ProductsCarouselEb.vue'
  }, {
    name: 'tag_list_block',
    path: 'Global/TagListBlock.vue',
    additional: {
      query: 'categories',

      handler(arg) {
        return {
          hashes: arg.items.map(e => e.hash)
        };
      }

    }
  }, {
    name: 'tag_list_image',
    path: 'Global/TagListImage.vue',
    additional: {
      query: 'categories',

      handler(arg) {
        return {
          hashes: arg.items.map(e => e.hash)
        };
      }

    }
  }, {
    name: 'home_old_carousel',
    path: 'Home/HomeOldCarousel.vue'
  }, {
    name: 'home_carousel',
    path: 'Home/HomeCarousel.vue'
  }, {
    name: 'slider_with_cta',
    path: 'Home/SliderWithCta.vue'
  }, {
    name: 'home_blog',
    path: 'Home/HomeBlog.vue',
    article: true
  }, {
    name: 'home_block_text',
    path: 'Home/HomeBlockText.vue'
  }, {
    name: 'home_block_battle',
    path: 'Home/HomeBlockBattle.vue'
  }, {
    name: 'home_olapic',
    path: 'Home/HomeOlapic.vue'
  }, {
    name: 'sustainable_development',
    path: 'Home/HomeSustainableDevelopment.vue'
  }, {
    name: 'block_newsletter',
    path: 'Home/HomeNewsletter.vue'
  }, {
    name: 'home_block_event',
    path: 'Home/HomeBlockEvent.vue'
  }, {
    name: 'block_catalog',
    path: 'Home/HomeGetCatalog.vue'
  }, {
    name: 'christmas_destocking_banner',
    path: 'Christmas/ChristmasDestockingBanner.vue'
  }, {
    name: 'announcement_banner',
    path: 'Global/AnnouncementBanner.vue'
  }, {
    name: 'block_order',
    path: 'Generic/BlockOrder.vue'
  }, {
    name: 'article_dispatch',
    path: 'Article/ArticleDispatch.vue'
  }, {
    name: 'global_footer',
    path: 'Global/GlobalFooter.vue'
  }, {
    name: 'link_block',
    path: 'Generic/LinkBlock.vue'
  }]
};